console.log("account.js loaded...");
const root = document.getElementById('skilltrack-dashboard');

// ===== CONFIG =====
const PROXY_BASE = root?.dataset?.apiBase || '/apps/skilltrack';   // App Proxy base
const BACKEND_BASE = 'https://backend.skilltrack.fun/api';       // optional later
const USE_BACKEND_FALLBACK = false;

// ===== DOM =====
const $current = document.getElementById('st-current');
const $total   = document.getElementById('st-total');
const $msg     = document.getElementById('redeem-msg');
const $code    = document.getElementById('redeem-code');
const $redeem  = document.getElementById('redeem-btn');
const $order   = document.getElementById('order-btn');
const $resend  = document.getElementById('resend-btn');
const $vmsg    = document.getElementById('verify-msg');
const $emailIn = document.getElementById('email-input');
const $emailBtn= document.getElementById('email-change-btn');
const $emailMsg= document.getElementById('email-msg');
const $deleteF = document.getElementById('st-delete');
const $deleteM = document.getElementById('delete-msg');
const $pwEmail = document.getElementById('password-email');
const $pwBtn   = document.getElementById('password-reset-btn');
const $pwMsg   = document.getElementById('password-reset-msg');

// ===== Helpers =====
function uuidv4(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,c=>{
        const r = Math.random()*16|0, v = c==='x'?r:(r&0x3|0x8);
        return v.toString(16);
    });
}

function setMsg(el, text, ok){
    if(!el) return;
    el.textContent = text || '';
    el.classList.remove('status-ok','status-error');
    if(text){ el.classList.add(ok ? 'status-ok' : 'status-error'); }
}
function toNum(x){ const n = Number(x); return Number.isFinite(n) ? n : null; }

function readCurrentOnPage(){
    return toNum(document.getElementById('st-current')?.textContent);
}
function writeUserToStorageSafe(patch){
    try{
        const raw = getUser() || sessionStorage.getItem('user') || '{}';
        const u = JSON.parse(raw);
        if (patch.current_tokens != null) u.tokens = patch.current_tokens;
        if (patch.total_tokens   != null) u.total_tokens = patch.total_tokens;
        setUser(u);
    }catch(_){}
}

// Read Bearer token
function getAuthToken(){
    try{
        let t = getToken() || sessionStorage.getItem('token');
        if (t && t[0] === '"') t = JSON.parse(t);
        if (!t){
        const raw = getUser() || sessionStorage.getItem('user');
        if (raw){
            const u = JSON.parse(raw);
            t = u?.token || u?.data?.token;
        }
        }
        return t || null;
    }catch(_){ return null; }
}

// Prefill token UI from storage
function displayUserInfoFromStorage(){
    try {
        console.log('[displayUserInfoFromStorage] Displaying user info from storage');
        const user = getUser() || JSON.parse(sessionStorage.getItem('user'));
        if(!user) return;
        console.log('Displaying user info from storage:', user);
        if (typeof user.tokens === 'number')       $current.textContent = user.tokens;
        if (typeof user.total_tokens === 'number') $total.textContent   = user.total_tokens;
        console.log('User email from storage:', user.email);
        console.log('Email input element:', $emailIn);
        console.log('Email input element.value:', /** @type {HTMLInputElement} */($emailIn).value);
        /** @type {HTMLInputElement} */($emailIn).value = user.email;
        /** @type {HTMLInputElement} */($pwEmail).value = user.email;
    } catch(e){ console.warn('Could not read user from storage:', e); }
}
displayUserInfoFromStorage();

// Unified fetch through App Proxy (send BOTH headers)
async function apiFetch(path, opts = {}){
    const token = getAuthToken();
    const headers = {
        'Content-Type': 'application/json',
        'Idempotency-Key': uuidv4(),
        ...(opts.headers || {})
    };
    if (token){
        headers['Authorization']     = 'Bearer ' + token; // direct/CORS calls
        headers['X-Skilltrack-Auth'] = 'Bearer ' + token; // read by proxy/backend
    }

    try{
        const proxyRes = await fetch(`${PROXY_BASE}${path}`, { ...opts, headers, credentials:'include' });
        if (proxyRes.ok || !USE_BACKEND_FALLBACK) return proxyRes;
        return await fetch(`${BACKEND_BASE}${path}`, { ...opts, headers, credentials:'omit', mode:'cors' });
    }catch(err){
        throw err;
    }
}

// ===== Redeem (robust; no more “0” flash) =====
$redeem?.addEventListener('click', async function(){
    const codeVal = ($code?.value||'').trim();
    if(!codeVal){ setMsg($msg,'Please enter a code.', false); return; }

    const authToken = getAuthToken();
    if (!authToken){ setMsg($msg,'Please sign in first, then try again.', false); return; }

    setMsg($msg,'Redeeming…', true);
    $redeem.disabled = true;

    try{
        const res  = await apiFetch('/tokens/redemptions', {
        method: 'POST',
        body: JSON.stringify({ tokenCode: codeVal })
        });

        let data = null;
        try{ data = await res.json(); }catch(_){}

        if (res.ok){
        // Accept multiple shapes
        const curFromBalance = toNum(data?.balance?.current_tokens);
        const totFromBalance = toNum(data?.balance?.total_tokens);
        const curFlat        = toNum(data?.current_tokens);
        const totFlat        = toNum(data?.total_tokens);
        const delta          = toNum(data?.result); // tokens added

        let newCurrent = null;
        let newTotal   = null;

        if (curFromBalance != null) newCurrent = curFromBalance;
        else if (curFlat != null)   newCurrent = curFlat;
        else if (delta != null){
            const before = readCurrentOnPage();
            if (before != null) newCurrent = before + delta;
        }

        if (totFromBalance != null) newTotal = totFromBalance;
        else if (totFlat != null)   newTotal = totFlat;

        // Update UI only with valid numbers
        if (newCurrent != null) $current.textContent = String(newCurrent);
        if (newTotal   != null) $total.textContent   = String(newTotal);

        // Persist & notify header only when valid
        const patch = {};
        if (newCurrent != null) patch.current_tokens = newCurrent;
        if (newTotal   != null) patch.total_tokens   = newTotal;
        if (patch.current_tokens != null || patch.total_tokens != null){
            writeUserToStorageSafe(patch);
            if (patch.current_tokens != null){
            window.dispatchEvent(new CustomEvent('st:tokens-updated', { detail:{ current: patch.current_tokens }}));
            }
        }

        setMsg($msg, data?.message || 'Voucher redeemed.', true);
        $code.value = '';

        } else {
        const msg =
            data?.message
            || (res.status === 404 ? 'Redeem route is not available on the app proxy. Ask your dev to expose /tokens/redemptions via /apps/skilltrack.'
            :  (res.status === 401 || res.status === 403) ? 'Unauthorized. Please sign in again.'
            :  (res.status === 400 ? 'Invalid or already used code.' : 'Could not redeem this code. Please try again.'));
        setMsg($msg, msg, false);
        }
    }catch(err){
        console.error('Redeem failed:', err);
        setMsg($msg,'Network/CORS error. Use the app proxy or enable CORS on the backend.', false);
    }finally{
        $redeem.disabled = false;
    }
});

/* Order more SEND EMAIL TO CHRISTIAN PREVIOUS LOGIC

// ===== Order more (via App Proxy → backend /api/tokens/orders) =====
const amtEl = document.getElementById('order-amount');
const amt = Math.max(1, Number(amtEl?.value) || 25); // min. 1

$order?.addEventListener('click', async function(){
try{
const res = await apiFetch('/tokens/orders', {
    method: 'POST',
    body: JSON.stringify({ amount: amt }) // brug den læste værdi
});

const data = await res.json().catch(()=>({}));

if (res.ok && data.checkout_url){
    window.location.href = data.checkout_url;
    return;
}

alert((data && data.message) || 'Request sent. We will contact you shortly.');
} catch(e){
alert('Network error. Please try again.');
}
});

 */

/* New Order More Relink to Prices page */
$order?.addEventListener('click', function(){
  window.location.href = '/pages/prices';
});

// ===== Resend verification =====
$resend?.addEventListener('click', async function(){
setMsg($vmsg,'Sending…', true);
try{
    const res = await apiFetch('/account/resend-verification', { method:'POST' });
    const data = await res.json().catch(()=>({}));
    if(res.ok){ setMsg($vmsg, data.message||'Verification email sent.', true); }
    else{ setMsg($vmsg, (data&&data.message)||'Could not send verification email.', false); }
}catch(e){ setMsg($vmsg,'Network error. Please try again.', false); }
});

// ===== Change email =====
$emailBtn?.addEventListener('click', async function(){
const newEmail = ($emailIn?.value||'').trim();
if(!newEmail){ setMsg($emailMsg,'Please enter an email.', false); return; }
setMsg($emailMsg,'Updating…', true); $emailBtn.disabled = true;
try{
    const res = await apiFetch('/account/update-email', { method:'POST', body: JSON.stringify({ email:newEmail }) });
    const data = await res.json().catch(()=>({}));
    if(res.ok){ setMsg($emailMsg, data.message||'Email updated.', true); }
    else{ setMsg($emailMsg, (data&&data.message)||'Could not update email.', false); }
}catch(e){ setMsg($emailMsg,'Network error. Please try again.', false); }
finally{ $emailBtn.disabled = false; }
});

// ===== Send password reset link (Shopify page) =====
$pwBtn?.addEventListener('click', function(){
    const email = ($pwEmail?.value || $emailIn?.value || '').trim();
    if (!email){ setMsg($pwMsg,'Please enter your email.', false); return; }
    // TODO: not working, scripts are not loaded:
    // const url = `/account/login?recover=1&email=${encodeURIComponent(email)}#recover`;
      const url = `/pages/resetpassword?email=${encodeURIComponent(email)}`;
    // const url = '/account/login#recover'; 
    console.log('[account.js] Redirecting to password reset URL:', url);
    window.location.href = url;
    // window.location.replace(url);
    // location.assign(url);
    // setTimeout(() => window.location.reload(), 300);

    /*
    // workaraound for Shopify redirect bug:
    // Create a real anchor and click it (mimics a user action)
    const link = document.createElement('a');
    link.href = url;
    link.rel = 'nofollow';
    link.dataset.turbo = 'false';   // optional safety for Turbo
    link.dataset.noInstant = 'true';
    document.body.appendChild(link);
    link.click();
    */
});

// ===== Delete account (proxy) =====
$deleteF?.addEventListener('submit', async function(ev){
  ev.preventDefault();

  const ok = window.confirm('Are you sure? This cannot be undone.');
  if (!ok) return;

  $deleteM.textContent = 'Deleting account...';

  try{
    const authToken = getAuthToken();
    if (!authToken){
      $deleteM.textContent = 'Please sign in first, then try again.';
      return;
    }

    const res = await apiFetch('/auth/me', {
      method: 'DELETE',
      headers: {
        'Accept': '*/*',
        'Authorization': `Bearer ${authToken}`
      }
    });

    const data = await res.json().catch(()=>({}));

    if (res.ok){
      $deleteM.textContent = data?.message || 'Account deleted. Logging out...';

      try{
        removeFromLocalStorageForEnv('token');
        removeFromLocalStorageForEnv('user');
        removeFromLocalStorageForEnv('st_access_token');
        removeFromLocalStorageForEnv('skilltrack_token');
      }catch(_){}

      // hard reload like your header.js signout
      window.location.replace('/');
      return;
    }

    $deleteM.textContent = data?.message || `Could not delete account (${res.status}).`;
  }catch(e){
    $deleteM.textContent = 'Network error. Please try again.';
  }
});


